import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';
import { shareReplay, tap } from 'rxjs/operators';

export interface IPostCode {
  text: string;
  lastId: string;
}
export interface IAddressDetails {
  lastId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClientProfileService {
  private customerApi = environment.customerApiUrl;
  private identityApi = environment.identityApiUrl;

  constructor(protected http: HttpClient) {
  }

  updateClientDetail(clientDetail: any): Observable<any> {
    return this.http.post<any>(`${this.customerApi}/customer/update-account-detail`, clientDetail);
  }
  getPostCode(text: IPostCode): Observable<any> {
    return this.http.post<any>(`${this.customerApi}/customer/find-address`, text);
  }
  getAddressDetails(text: IAddressDetails): Observable<any> {
    return this.http.post<any>(`${this.customerApi}/customer/retrieve-address`, text);
  }
  getAdditionalClientDetail(): Observable<any> {
    return this.http.get<any>(`${this.customerApi}/customer/get-account-detail`);
  }

  public validateIban(iban: string): Observable<any> {
    return this.http.get(`${this.customerApi}/banking/validate-iban/${iban}`);
  }

  public verifySwiftCode(swift: string): Observable<any> {
    return this.http.get(`${this.customerApi}/banking/validate-swift/${swift}`);
  }

  singleEmailAccounts$ = new BehaviorSubject(false);

  public getProfiles(email): Observable<any> {

    return this.http.post(`${this.customerApi}/customer/get-single-email-accounts`, email).pipe(
      tap(res => {
        if(res.length > 1) {
          this.singleEmailAccounts$.next(true);
        } else {
          this.singleEmailAccounts$.next(false);
        }
      }),
    );
  }

  public changeSelectedAccount(lead): Observable<any> {
    return this.http.post(`${this.identityApi}/account/change-selected-account/`, lead);
  }
}
